import type { Middleware } from "openapi-fetch";

export type * from "./doors-api";

export class LoginExpiredError extends Error {}

export const AuthMiddleware = (jwt: string): Middleware => ({
  async onRequest({ request }) {
    request.headers.set("Authorization", `Bearer ${jwt}`);
    return request;
  },
  async onResponse({ request, response }) {
    if (!response.ok) {
      const msg = await response.text();
      const e = new Error(
        `'${request.url}' fetch failed (${response.status}): ${msg}`
      );
      // expired, invalid, etc JWTs all need a new login
      if (response.status == 401 && msg.includes("Signature")) {
        throw new LoginExpiredError(e.message);
      }
      throw e;
    }
  }
});
